import { useCallback } from "react";
import LayerSelector from "./LayerSelector";

/**
 * The Default Map Layer Selector Component
 * @param {{
 *  "onSelect": () => void,
 *  "selected": boolean | null | undefined
 * }} props
 * @returns import("react").JSX.Element
 */
export default function SatelliteLayerSelector({ onSelect, selected }) {
  const handleSelect = useCallback(() => {
    onSelect();
  }, [onSelect]);

  return (
    <LayerSelector
      type="satellite"
      onSelect={handleSelect}
      selected={selected}
    />
  );
}
